import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { DateTimeInput } from "@circleco/compass/components/DateTimeInput";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
import { endOfDay } from "date-fns";
import {
  useCallback,
  useMemo,
  type MouseEvent,
  type PointerEvent,
} from "react";
import { Controller, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

const parseCreatedAt = (value: string | null | undefined): Date | undefined => {
  if (!value) {
    return undefined;
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? undefined : date;
};

export const PublishTimeInput = () => {
  const { control } = useFormContext<PostFormValues>();
  const maxDate = useMemo(() => endOfDay(new Date()), []);
  const disabledDays = useMemo(() => ({ after: maxDate }), [maxDate]);
  const stopInteractionPropagation = useCallback(
    (event: MouseEvent | PointerEvent) => {
      event.stopPropagation();
    },
    [],
  );
  const isMobile = useIsMobile();

  return (
    <Controller
      control={control}
      name="created_at"
      render={({ field }) => (
        <DateTimeInput
          data-testid="quick-post-v3-publish-time"
          disabledDays={disabledDays}
          endMonth={maxDate}
          horizontalLayoutRatio="40/60"
          label={t("publish_date")}
          labelTooltip={t("publish_date_description")}
          layout={isMobile ? "vertical" : "horizontal"}
          onChange={date => {
            field.onChange(date?.toISOString() ?? null);
          }}
          rootProps={{
            onClick: stopInteractionPropagation,
            onPointerDown: stopInteractionPropagation,
          }}
          value={parseCreatedAt(field.value)}
        />
      )}
    />
  );
};
